// extracted by mini-css-extract-plugin
export default {"source":"WebSearchSource__source--2TvnE","match":"WebSearchSource__match--13GkR"};